import { Button, Modal } from "flowbite-react";
import { HiDocumentDuplicate } from "react-icons/hi";
import { SitePage } from "../../Models/SitePage";

type CopySitePageModalProps = {
  show: boolean;
  page: SitePage | null;
  isCopying: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function CopySitePageModal({
  show,
  page,
  isCopying,
  onClose,
  onConfirm,
}: CopySitePageModalProps) {
  if (!page) return null;

  return (
    <Modal show={show} size="md" onClose={onClose} popup dismissible>
      <Modal.Header className="border-b border-gray-200 pb-4">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
            <HiDocumentDuplicate className="h-6 w-6 text-blue-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Copy Site Page</h3>
            <p className="text-sm text-gray-500">Create a duplicate to edit</p>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="pt-6">
        <p className="text-gray-700">
          Copy page{" "}
          <span className="font-semibold text-gray-900">
            {page.title ?? page.header ?? "Untitled"}
          </span>
          ? The copy will not appear in the navigation menu until you enable
          it.
        </p>
      </Modal.Body>

      <Modal.Footer className="border-t border-gray-200 pt-4">
        <Button color="gray" onClick={onClose} disabled={isCopying}>
          Cancel
        </Button>
        <Button
          className="bg-blue-600 hover:bg-blue-700"
          onClick={onConfirm}
          disabled={isCopying}
        >
          {isCopying ? "Copying..." : "Copy Page"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
